<template>
  <v-tooltip :disabled="!tooltip" top>
    <template v-slot:activator="{ on: tooltip }">
      <v-list-item dense class="pa-0" v-on="{ ...tooltip }">
        <v-list-item-avatar size="30" color="light-blue darken-4" class="mr-2 justify-center">
          <v-icon small color="white">{{ icon.account }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ dense ? ownerObject.nombres : ownerObject.nombreCompleto }}</v-list-item-title>
          <v-list-item-subtitle>{{ dense ? ownerObject.paterno :ownerObject.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <span>{{ 
      ownerObject.email
    }}</span>
  </v-tooltip>
</template>

<script>
import { mdiAccountOutline } from '@mdi/js'
import { userData } from '@/store/helpers'

export default {
  name: 'OwnerAvatar',
  props: {
    value: {
      type: String
    },
    dense: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icon: {
        account: mdiAccountOutline
      }
    }
  },
  computed: {
    ...userData,
    ownerObject() {
      if (this.value == this.userId) {
        let owner = Object.assign(new Object(), this.accountData)
        owner.nombreCompleto = owner.nombres + ' ' + owner.paterno + ' ' + owner.materno
        return owner
      }
      return { 
        nombre: '',
        paterno: '',
        materno: '',
        nombreCompleto: '', 
        email: '' 
      }
    }
  }
}
</script>
